import { useEffect } from 'react'
import style from '../index.module.scss'
import { Form, Button, Input, Modal, message } from 'antd'
import * as apis from '../../../api/user'

interface Props {
    visible: any
    userInfo?: any
    onClose: () => void;
    onRefresh: () => void;
}

const EditPassWord = (props: Props) => {


    const [form] = Form.useForm();


    useEffect(() => {
    }, [])
    /**
    * @name 修改密码
    */
    const onFinish = async (values: any) => {
        try {
            let res: any
            if (props.userInfo.hasPassword) {
                res = await apis.accountPassword(form.getFieldsValue())
            } else {
                res = await apis.postAccountPassword(form.getFieldsValue().newPassword)
            }
            console.log(res)
            if (res?.ok) {
                message.success('修改成功')
                form.resetFields();
                props.onClose()
                props.onRefresh()
            }
        } catch (err) {

            form.resetFields();
        }
    };
    /**
       * @name 校验失败
       */
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };
    /**
   * @name 重置
   */
    const reset = () => {
        form.resetFields();
        props.onClose()

    }
    return (
        <Modal
            centered
            footer={null}
            onCancel={() => {
                reset()
            }}
            width={'40%'}
            title={'修改密码'}
            open={props.visible}>
            <div>
                <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 12 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                >
                    {props.userInfo.hasPassword ?
                        <Form.Item
                            label="当前密码"
                            name="oldPassword"
                            rules={[{ required: true, message: '请输入当前密码' }]}
                        >
                            <Input.Password className={style.input} />
                        </Form.Item> : <></>
                    }
                    <Form.Item
                        label="新密码"
                        name="newPassword"
                        rules={[{ required: true, message: '请输入新密码' }]}
                    >
                        <Input.Password className={style.input} />
                    </Form.Item>
                    <Form.Item
                        label="确认密码"
                        name="checkNewPassword"
                        rules={[{ required: true, message: '请确认新密码' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('两次密码输入不一致'));
                            },
                        }),]}
                    >
                        <Input.Password className={style.input} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 12 }}>
                        <div data-flex='main:left' >
                            {/* <Button className='btn_default mr-10 btn' onClick={() => { setPassVisible(false); form.resetFields(); }} >取消</Button> */}
                            <Button className='btn_default mr-10 btn' onClick={() => { reset() }} >取消</Button>
                            <Button className='btn_dark btn' htmlType="submit">确认</Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    )
}

export default EditPassWord